import { useState } from 'react';
import { useAuth } from '@/hooks/useAuth';
import { Button } from '@/components/ui/Button';
import { Input } from '@/components/ui/Input';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/Card';
import { Factory, AlertCircle } from 'lucide-react';

export function Login() {
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [token2fa, setToken2fa] = useState('');
  const { login, verificar2FA, isLoading, error, loginData } = useAuth();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (loginData?.requires2FA) {
      verificar2FA({ userId: loginData.userId, token: token2fa });
    } else {
      login({ email, senha });
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-gradient-to-br from-gray-50 to-white p-4">
      <div className="w-full max-w-md">
        {/* Logo */}
        <div className="flex items-center justify-center gap-3 mb-8">
          <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-primary to-primary-600 flex items-center justify-center">
            <Factory className="h-7 w-7 text-white" />
          </div>
          <span className="text-2xl font-bold text-gray-900">Fort3D</span>
        </div>

        <Card className="border-0 shadow-elevated">
          <CardHeader className="text-center pb-2">
            <CardTitle className="text-2xl text-gray-900">
              {loginData?.requires2FA ? 'Verificação em Duas Etapas' : 'Acesso Administrativo'}
            </CardTitle>
            <CardDescription>
              {loginData?.requires2FA 
                ? 'Insira o código de 6 dígitos gerado em seu app de autenticação.' 
                : 'Entre com suas credenciais para acessar o painel'}
            </CardDescription>
          </CardHeader>
          <CardContent>
            <form onSubmit={handleSubmit} className="space-y-4">
              {!loginData?.requires2FA ? (
                <>
                  <Input
                    label="Email"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="admin@fort3d.com"
                    required
                  />
                  <Input
                    label="Senha"
                    type="password"
                    value={senha}
                    onChange={(e) => setSenha(e.target.value)}
                    placeholder="••••••••"
                    required
                  />
                </>
              ) : (
                <Input
                  label="Código Autenticador (2FA)"
                  type="text"
                  maxLength={6}
                  value={token2fa}
                  onChange={(e) => setToken2fa(e.target.value.replace(/\D/g, ''))}
                  placeholder="000 000"
                  required
                  autoFocus
                />
              )}
              
              {error && (
                <div className="flex items-center gap-2 rounded-lg bg-red-50 p-3 text-sm text-red-600">
                  <AlertCircle className="h-4 w-4" />
                  {loginData?.requires2FA ? 'Código inválido' : 'Credenciais inválidas'}
                </div>
              )}

              <Button
                type="submit"
                className="w-full"
                variant="nuvem"
                size="lg"
                isLoading={isLoading}
              >
                {loginData?.requires2FA ? 'Confirmar Código' : 'Entrar'}
              </Button>

              {loginData?.requires2FA && (
                <Button
                  type="button"
                  onClick={() => window.location.reload()}
                  className="w-full"
                  variant="ghost"
                >
                  Voltar ao login
                </Button>
              )}
            </form>

            <div className="mt-6 text-center text-sm text-gray-500">
              <a href="/" className="hover:text-primary transition-colors">
                ← Voltar para a loja
              </a>
            </div>
          </CardContent>
        </Card>

        <p className="text-center text-xs text-gray-400 mt-8">
          © 2024 Fort3D Indústria e Comércio LTDA
        </p>
      </div>
    </div>
  );
}
